import React from "react";
import { Link } from "react-router-dom";
import "../../../App.css";

const NewsPlaceholder = () => (
  <div className="blog-shell">
    <div className="blog-panel">
      <div className="blog-kicker">POGFORTS NEWS</div>
      <h1 className="blog-title">News</h1>
      <p className="blog-subtitle">
        The News system is reserved for the next deployment phase.
      </p>
      <Link to="/blog" className="blog-button">Open Blog</Link>
    </div>
  </div>
);

export default NewsPlaceholder;
